import { useEffect, useState } from 'react';
import VistaprintAuth from '@vp/auth';

export interface Identity {
    accessToken: string;
    authorizationHeader: string;
    canonicalId: string;
    hasIdentityError: boolean;
}

export function useOnUserIdentityUpdate(onIdentityUpdate?: (identity: Identity) => void): Identity {
    const [identity, setIdentity] = useState<Identity>({
        accessToken: '',
        canonicalId: '',
        authorizationHeader: '',
        hasIdentityError: false,
    });

    useEffect(() => {
        const auth = new VistaprintAuth.WebAuth();
        auth.onUserIdentityUpdate((identity: Identity) => {
            if (!identity) {
                setIdentity({
                    accessToken: '',
                    canonicalId: '',
                    authorizationHeader: '',
                    hasIdentityError: true,
                });
                return;
            }

            if (onIdentityUpdate) {
                onIdentityUpdate({ ...identity, hasIdentityError: false });
            }

            setIdentity({ ...identity, hasIdentityError: false });
        });
    }, []);

    return identity;
}
